/**
 * Monetization Analytics — safe event tracking
 *
 * Never crashes if analytics is unavailable.
 * Logs to console in dev, posts to /api/analytics/track in prod.
 */

const API = process.env.REACT_APP_BACKEND_URL;

function getToken() {
  return localStorage.getItem('token');
}

async function trackEvent(event, data = {}) {
  try {
    const token = getToken();
    if (!token) return;
    await fetch(`${API}/api/analytics/monetization`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ event, data, ts: new Date().toISOString() }),
    }).catch(() => {});
  } catch {
    // No-op — analytics must never crash the app
  }
}

// ═══════════════════════════════════════════════════════
// TRACKED EVENTS
// ═══════════════════════════════════════════════════════

export const trackBoostAttemptWithoutCoins = (boostType, shortage) =>
  trackEvent('boost_attempt_without_coins', { boostType, shortage });

export const trackBuyCoinsOpened = (source) =>
  trackEvent('buy_coins_opened', { source });

export const trackPackageSelected = (packageId, region) =>
  trackEvent('package_selected', { packageId, region });

export const trackPaymentStarted = (method, packageId) =>
  trackEvent('payment_started', { method, packageId });

export const trackPaymentCompleted = (method, packageId, coins) =>
  trackEvent('payment_completed', { method, packageId, coins });

export const trackSubscriptionClicked = (planId) =>
  trackEvent('subscription_clicked', { planId });

export const trackSubscriptionConverted = (planId) =>
  trackEvent('subscription_converted', { planId });

export const trackPackageViewed = (packageId) =>
  trackEvent('package_viewed', { packageId });

export const trackCvUnlockViewed = (method) =>
  trackEvent('cv_unlock_prompt_viewed', { method });

export const trackCvUnlockWithCoins = () =>
  trackEvent('cv_unlock_with_coins', {});

export const trackCvUnlockWithSubscription = () =>
  trackEvent('cv_unlock_with_subscription', {});

export const trackBoostUsed = (adId, coinsSpent) =>
  trackEvent('boost_used', { adId, coinsSpent });

export const trackUpgradeProClicked = (source) =>
  trackEvent('upgrade_pro_clicked', { source });

export const trackWalletViewed = (balance, monthlySpend) =>
  trackEvent('wallet_viewed', { balance, monthlySpend });
